<template>
  <div class="counter-input" @click.prevent>
    <div>
      <div class="label text5">{{ label }}</div>
      <div v-if="description" class="counter-input-description text8">
        {{ description }}
      </div>
    </div>

    <div class="counter-buttons">
      <button
        :id="`${id}-decrement`"
        :disabled="value <= minimum"
        @click.prevent="updateValue(value - 1)"
        aria-label="Decrement"
      >
        <FontIcon name="ui_moins" />
      </button>

      <div class="value text6">{{ value }}</div>

      <button
        :id="`${id}-increment`"
        :disabled="value >= maximum"
        @click.prevent="updateValue(value + 1)"
        aria-label="Increment"
      >
        <FontIcon name="ui_plus" />
      </button>
    </div>
  </div>
</template>

<style lang="scss">
.counter-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: rem(30px);

  .counter-input-description {
    @include setColor(--color-text);
  }

  .counter-buttons {
    display: flex;
    align-items: center;
  }

  .value {
    margin: rem(0 10px);
    vertical-align: middle;
    width: rem(20px);
    text-align: center;
  }

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    width: rem(25px);
    height: rem(25px);
    padding: 0;
    border-width: 1px;
    border-style: solid;
    @include setColor(--color-cta, border-color);
    outline: none;
    cursor: pointer;
    border-radius: rem(20px);
    font-size: rem(14px);

    &:disabled {
      opacity: 0.5;
    }
  }
}
</style>

<script>
import FontIcon from "../../FontIcon";

export default {
  components: {
    FontIcon,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    minimum: {
      type: Number,
      default: 0,
    },
    maximum: {
      type: Number,
      default: Infinity,
    },
  },

  methods: {
    updateValue(value) {
      this.$emit(
        "update:value",
        Math.max(this.minimum, Math.min(this.maximum, value)),
      );
    },
  },
};
</script>
